import { SET_LEASE_STATUSES, RESET_LEASE_STATUSES } from './actionTypes';

export const setLeaseStatuses = (leaseStatuses) => ({
  type: SET_LEASE_STATUSES,
  payload: leaseStatuses,
});

export const resetLeaseStatuses = () => ({
  type: RESET_LEASE_STATUSES,
});